<template>
    <div class="nk-footer-copyright">{{trans('general.version')+' '+getConfig('v')}} {{getConfig('footer_credit')}}</div>
</template>
<script>
    export default { 
    	methods: {
    		getConfig(config){
    			return helper.getConfig(config);
    		}
    	}
    }
</script>